import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center bg-cover bg-center" style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/fd723d4dd8c6e98f368f9fb182ceb1f1.jpg)' }}>
          <div className="absolute inset-0 bg-black/30"></div>
          <div className="relative max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">
                Experience <span className="italic">Luxury</span> Private Jet Services
              </h1>
              <p className="text-lg mb-8 text-white/90">
                Milajet Havacilik offers unparalleled private jet services, connecting you to destinations across Europe, Africa, the Middle East, and Asia. Fly in comfort and style with our exclusive Gulfstream IV-SP aircraft. Your journey, our priority.
              </p>
              <Link
                to="/book-now"
                className="inline-block bg-blue-600 text-white px-8 py-3 rounded hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Charter
              </Link>
            </div>
          </div>
        </section>

        {/* Destinations Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg mb-4 h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Eiffel%20Tower%20in%20Paris%20France%20at%20sunset%20with%20elegant%20cityscape%20view%2C%20romantic%20European%20destination%2C%20luxury%20travel%20photography%20with%20soft%20golden%20lighting%20and%20clear%20blue%20sky%2C%20professional%20architectural%20photography&width=400&height=500&seq=paris-destination-001&orientation=portrait"
                    alt="Paris, France"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <h5 className="font-bold text-xl mb-2">Paris, France</h5>
                <p className="text-gray-600 text-sm">
                  Experience the romance and culture of Paris with Milajet. Fly directly to the heart of Europe in unparalleled comfort and style.
                </p>
              </div>

              <div className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg mb-4 h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Great%20Pyramids%20of%20Giza%20in%20Cairo%20Egypt%20with%20sphinx%20under%20clear%20blue%20sky%2C%20ancient%20Egyptian%20monuments%2C%20luxury%20travel%20destination%20photography%20with%20warm%20desert%20tones%20and%20golden%20sunlight%2C%20professional%20architectural%20photography&width=400&height=500&seq=cairo-destination-002&orientation=portrait"
                    alt="Cairo, Egypt"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <h5 className="font-bold text-xl mb-2">Cairo, Egypt</h5>
                <p className="text-gray-600 text-sm">
                  Discover the ancient wonders of Cairo. Milajet offers exclusive flights to explore the rich history and vibrant culture of Egypt.
                </p>
              </div>

              <div className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg mb-4 h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Burj%20Khalifa%20and%20Dubai%20skyline%20at%20dusk%20with%20modern%20skyscrapers%20and%20luxury%20architecture%2C%20futuristic%20Middle%20Eastern%20cityscape%2C%20premium%20travel%20destination%20with%20golden%20hour%20lighting%20and%20clear%20sky%2C%20professional%20urban%20photography&width=400&height=500&seq=dubai-destination-003&orientation=portrait"
                    alt="Dubai, UAE"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <h5 className="font-bold text-xl mb-2">Dubai, UAE</h5>
                <p className="text-gray-600 text-sm">
                  Indulge in the luxury and innovation of Dubai. Fly with Milajet for a seamless and opulent travel experience in the Middle East.
                </p>
              </div>

              <div className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg mb-4 h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Traditional%20Japanese%20temple%20in%20Kyoto%20with%20cherry%20blossom%20trees%20and%20zen%20garden%2C%20serene%20Asian%20cultural%20destination%2C%20luxury%20travel%20photography%20with%20soft%20natural%20lighting%20and%20peaceful%20atmosphere%2C%20professional%20architectural%20photography&width=400&height=500&seq=kyoto-destination-004&orientation=portrait"
                    alt="Kyoto, Japan"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <h5 className="font-bold text-xl mb-2">Kyoto, Japan</h5>
                <p className="text-gray-600 text-sm">
                  Immerse yourself in the tranquility and beauty of Kyoto. Milajet provides direct flights to experience the cultural heart of Japan.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Aircraft Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h5 className="text-blue-600 font-semibold mb-2">Our Aircraft</h5>
                <h3 className="text-4xl font-bold mb-6">
                  Gulfstream IV-SP: Your <em>Ultimate</em> Flying Experience
                </h3>
                <p className="text-gray-600 mb-6">
                  Experience unparalleled luxury and performance with our Gulfstream IV-SP. This exceptional aircraft offers a spacious cabin, advanced avionics, and long-range capabilities, making it perfect for your business or leisure travel needs. Fly in style and comfort to destinations across Europe, Africa, the Middle East, and Asia.
                </p>
                <Link
                  to="/our-services"
                  className="inline-block bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Learn More
                </Link>
              </div>
              <div>
                <img
                  src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/be2cafd0cba39437049d5eb2d00be088.jpeg"
                  alt="Gulfstream IV-SP Interior"
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Section */}
        <section className="py-20 bg-black text-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold mb-4">
                Why <em>Milajet Havacilik</em> is Your Best Choice for Private Jet Travel
              </h2>
              <p className="text-white/80 max-w-3xl mx-auto">
                Choosing Milajet Havacilik means opting for unparalleled luxury, flexibility, and convenience. We prioritize your comfort and time, offering bespoke travel solutions tailored to your specific needs. With access to a wide range of destinations and a commitment to exceptional service, we ensure every journey is seamless and unforgettable. Experience the difference with Milajet Havacilik.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white/10 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20private%20jet%20cabin%20interior%20with%20spacious%20cream%20leather%20seats%20premium%20amenities%20elegant%20wood%20paneling%20soft%20ambient%20lighting%20comfortable%20seating%20arrangement%20executive%20business%20aviation%20high-end%20materials%20complete%20privacy%20sophisticated%20atmosphere%20refined%20craftsmanship%20exclusive%20travel%20experience%20modern%20design&width=600&height=400&seq=luxury-cabin-comfort-001&orientation=landscape"
                  alt="Luxury Cabin"
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h5 className="font-bold text-xl mb-3">Unmatched Comfort and Privacy Onboard</h5>
                  <p className="text-white/80 text-sm mb-4">
                    Experience the epitome of luxury with our meticulously designed cabins. Enjoy spacious seating, premium amenities, and complete privacy, ensuring a relaxing and productive journey. Your comfort is our top priority.
                  </p>
                  <Link to="/our-services" className="text-blue-400 hover:text-blue-300 text-sm cursor-pointer">
                    Learn More →
                  </Link>
                </div>
              </div>

              <div className="bg-white/10 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20airline%20pilot%20and%20crew%20in%20cockpit%20wearing%20uniform%20expert%20aviation%20team%20captain%20and%20co-pilot%20at%20controls%20modern%20aircraft%20flight%20deck%20advanced%20avionics%20displays%20focused%20professionals%20safety%20equipment%20sophisticated%20technology%20dedicated%20crew%20members%20aviation%20excellence&width=600&height=400&seq=expert-pilots-crew-002&orientation=landscape"
                  alt="Expert Pilots"
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h5 className="font-bold text-xl mb-3">Expert Pilots and Dedicated Crew</h5>
                  <p className="text-white/80 text-sm mb-4">
                    Our highly skilled pilots and dedicated crew are committed to providing a safe and seamless travel experience. With extensive training and a passion for excellence, they ensure every flight meets the highest standards of safety and service.
                  </p>
                  <Link to="/about-us" className="text-blue-400 hover:text-blue-300 text-sm cursor-pointer">
                    Learn More →
                  </Link>
                </div>
              </div>

              <div className="bg-white/10 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=World%20map%20showing%20global%20destinations%20with%20flight%20routes%20connecting%20Europe%20Africa%20Middle%20East%20Asia%20continents%20international%20travel%20network%20aviation%20paths%20luxury%20destinations%20worldwide%20reach%20flexible%20routing%20personalized%20itineraries%20global%20connectivity%20modern%20professional%20design&width=600&height=400&seq=global-destinations-003&orientation=landscape"
                  alt="Global Destinations"
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h5 className="font-bold text-xl mb-3">Global Reach and Flexible Destinations</h5>
                  <p className="text-white/80 text-sm mb-4">
                    Fly to your desired destinations across Europe, Africa, the Middle East, and Asia with ease. We offer flexible routing and personalized itineraries, allowing you to travel on your schedule and reach even the most remote locations.
                  </p>
                  <Link to="/our-services" className="text-blue-400 hover:text-blue-300 text-sm cursor-pointer">
                    Learn More →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Book Now CTA */}
        <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white text-center">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-4xl font-bold mb-4">Book Your Private Jet Now</h2>
            <p className="text-xl mb-8 text-white/90">
              Easily reserve your private jet online with Milajet Havacilik for seamless luxury travel across Europe, Africa, Middle East, and Asia.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/our-services"
                className="bg-white text-blue-600 px-8 py-3 rounded hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                Book Now
              </Link>
              <Link
                to="/contact"
                className="bg-transparent border-2 border-white text-white px-8 py-3 rounded hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                Contact via WhatsApp
              </Link>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold mb-6">About Milajet Havacilik</h2>
                <p className="text-gray-600">
                  Milajet Havacilik is dedicated to providing exceptional private jet services across Europe, Africa, the Middle East, and Asia. Our mission is to deliver safety, comfort, and exclusivity, ensuring every client experiences seamless and personalized air travel. With a focus on professionalism and high standards, we aim to be your trusted partner in luxury aviation.
                </p>
              </div>
              <div>
                <img
                  src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/036e19a2701002dfa08cbc2b81c18f6c.jpeg"
                  alt="Milajet Aircraft"
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
